var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 0.5C15.7761 0.5 16 0.723858 16 1L15.9995 3.5H19.5C19.6753 3.5 19.8354 3.59145 19.9253 3.73712L19.9642 3.8143L21.9642 8.8143C22.0847 9.11537 21.8915 9.44066 21.586 9.49278L21.5 9.5H20.9995L21 21C21 21.2455 20.8231 21.4496 20.5899 21.4919L20.5 21.5H1.5C1.22386 21.5 1 21.2761 1 21L0.999512 9.5H0.500005C0.17575 9.5 -0.0545165 9.1998 0.010548 8.89679L0.0357664 8.8143L2.03577 3.8143C2.10085 3.65159 2.24523 3.5369 2.4139 3.50745L2.5 3.5H5.99951L6 1C6 0.75454 6.17688 0.550392 6.41013 0.508056L6.5 0.5H15.5ZM19.9995 9.5H1.99951L2 20.5H3.99951L4 12C4 11.7545 4.17688 11.5504 4.41013 11.5081L4.5 11.5H17.5C17.7761 11.5 18 11.7239 18 12L17.9995 20.5H20L19.9995 9.5ZM10.5 12.5H5V20.5H10.5V12.5ZM17 12.5H11.5V20.5H17V12.5ZM14 6.5H13V5.5H9V6.5H8V5.5H6.5C6.22386 5.5 6 5.27614 6 5L5.99951 4.499L2.838 4.5L1.238 8.5H20.761L19.161 4.5L15.9995 4.499L16 5C16 5.24546 15.8231 5.44961 15.5899 5.49194L15.5 5.5H14V6.5ZM15 1.5H7V4.5H15V1.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/Store.7a523bdd728c9b5040f7203c03dda93f.svg";
export { ForwardRef as ReactComponent };